import * as React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router";
import { useDispatch } from "react-redux";

//store, state
import {
  updateActiveFormInstance,
  useAllPermissionCheck,
} from "../../store/base";
import {
  constants,
  useRoundingErrandsPaginationCount,
} from "../../store/roundingErrands";
import useActiveFilters from "../../hooks/useActiveFilters";
import usePermissionRedirect from "../../hooks/usePermissionRedirect";

//components & styles
import DetailPageHeaderMenu from "../Layouts/DetailPageHeaderMenu/DetailPageHeaderMenu";
import Errands from "./overview/Errands";
import Settings from "./overview/Settings";
import { DetailLayoutWrapper } from "../../components/sharedStyles";

import { StatusLabel } from "../../components/Lists/Base/CompleteList/styles";
import Areas from "./overview/Areas";
import Faults from "./overview/Faults";

export default function MainRoundingErrandOverview() {
  const { path, url } = useRouteMatch();
  const dispatch = useDispatch();
  const storeName = constants.STORE_NAME;
  const { filteredRealEstates } = useActiveFilters();

  usePermissionRedirect(["allow_errand_roundings", "view_can_roundingerrand"]);

  const [activeCount] = useRoundingErrandsPaginationCount({
    realEstates: filteredRealEstates,
    kindIsNull: true,
    isGov: false,
  });

  const SUB_PAGES = [
    {
      path: "/settings",
      label: "Ronderingsscheman",
      component: Settings,
    },
    {
      path: "/errands",
      label: "Ronderingar",
      component: Errands,
    },
    {
      path: "/errand-areas",
      label: "Ronderingsområden",
      component: Areas,
    },
    {
      path: "/errand-faults",
      label: "Avvikelser",
      component: Faults,
    },
  ];

  const subPageLinks = SUB_PAGES.map((sp) => ({
    url: `${url}${sp.path}`,
    label: sp.label,
    hasError: sp.hasError,
  }));

  const renderInfoPills = () => {
    return (
      <>
        <StatusLabel state={0} style={{ marginRight: 12 }}>
          Antal ärenden: {activeCount == null ? "Laddar..." : activeCount}
        </StatusLabel>
      </>
    );
  };

  React.useEffect(() => {
    dispatch(updateActiveFormInstance({ storeName, data: undefined }));
  }, []);

  return (
    <>
      <DetailLayoutWrapper>
        <DetailPageHeaderMenu
          title={`Ronderingar`}
          {...{ subPages: subPageLinks, renderInfoPills }}
        />

        <Switch>
          {SUB_PAGES.map((sp) => (
            <Route
              key={sp.path}
              path={`${path}${sp.path}`}
              component={sp.component}
            />
          ))}

          {/* Default sub page  */}
          <Redirect exact to={`${url}${SUB_PAGES[0].path}`} path={`${path}`} />
        </Switch>
      </DetailLayoutWrapper>
    </>
  );
}
